import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './components/Index'
//import vSelect from 'vue-select'

import axios from 'axios';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import VueIziToast from 'vue-izitoast';
import VueSweetalert2 from 'vue-sweetalert2';

import VueVideoPlayer from 'vue-video-player'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import 'vue-select/dist/vue-select.css';

//*************** ESTILOS GENERALES *******************
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/fontawesome_pro/css/all.css'

import 'izitoast/dist/css/iziToast.css';
import 'sweetalert2/dist/sweetalert2.min.css';

//*************** ESTILOS PROPIOS *******************
import './assets/style/css/main.css';
window.$ = require('jquery')
window.JQuery = require('jquery')


// ************** ICONS FONTAWESOME *******************
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'



library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.prototype.bus = new Vue;
/**AXIOS */

/*Datos de login */
var token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJJZFVzdWFyaW8iOiIxIiwiSWRQZXJmaWwiOiIxIiwiUGVyZmlsIjoiQWRtaW5pc3RyYWRvciIsIklkUHVlc3RvIjoiMSIsInRpbWVTdGFtcCI6IjIwMjAtMTEtMzAgMTA6NDM6NTEiLCJJZEN1ZW50YSI6MCwic3RhdHVzIjp0cnVlfQ._u_cZrqCkmrmtVBoM2-7FIpJrfF9FSxR9hCAFNlLw4Q";

Vue.prototype.$http = axios.create({
    //baseURL: 'https://unam.lugarcreativo.com.mx/services/api/v.1/',
    //baseURL: 'http://localhost/unamenes/api/v.1/',
    //baseURL: 'http://localhost/enesRep/api/v.1/',
    baseURL: 'http://enesmerida.unam.mx/services/api/v.1/',
    //baseURL: 'http://132.247.19.15/services/api/v.1/',
    headers: { 'Authorization': token },
});


//Vue.component('v-select', vSelect)

/*TOAST */
Vue.use(VueIziToast, {
    position: 'topCenter'
});

/** bootstrapVUe*/
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

/**ALERTSWEET */
Vue.use(VueSweetalert2);

/**Video reproductos */

Vue.use(VueVideoPlayer,
    /* {
  options: global default options,
  events: global videojs events
} */
)

// videojs plugin
const Plugin = videojs.getPlugin('plugin')
class ExamplePlugin extends Plugin {
    // something...
}
videojs.registerPlugin('examplePlugin', ExamplePlugin)

// videojs language
videojs.addLanguage('es', {
    Pause: 'Pausar',
    Unmute: 'Silenciar',
    Fullscreen: 'Pantalla completa',
    // something...
})

import VuePlyr from 'vue-plyr';
Vue.use(VuePlyr, {
    plyr: {
        pip: { enabled: false },
        fullscreen: { enabled: true },

    },
    emit: ['ended']
})

import MyPlugin from './config/general.js'
Vue.use(MyPlugin, Vue.prototype.$http, $)

new Vue({
    router,
    store,
    render: function(h) { return h(App) }
}).$mount('#app')